// Klik na fotografiju uz recenziju otvara je preko stranice, a ne u novoj kartici.
// Zatvara se iksom, klikom pored slike i tasterom Esc. Ako JS ne radi, link i dalje
// otvara sliku u novoj kartici, pa nista nije izgubljeno.
(function () {
  var sloj = null;

  function zatvori() {
    if (!sloj) return;
    sloj.remove();
    sloj = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', naTaster);
  }

  function naTaster(e) {
    if (e.key === 'Escape') zatvori();
  }

  function otvori(src) {
    zatvori();
    sloj = document.createElement('div');
    sloj.className = 'torbella-lupa';
    sloj.innerHTML =
      '<button type="button" class="torbella-lupa__x" aria-label="Zatvori">&times;</button>' +
      '<img class="torbella-lupa__slika" alt="">';
    sloj.querySelector('img').src = src;
    document.body.appendChild(sloj);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', naTaster);
    sloj.addEventListener('click', function (e) {
      // klik pored slike zatvara; klik na samu sliku ne
      if (e.target.classList.contains('torbella-lupa__slika')) return;
      zatvori();
    });
    sloj.querySelector('.torbella-lupa__x').focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.torbella-recenzija__slika');
    if (!a) return;
    e.preventDefault();
    otvori(a.getAttribute('href'));
  });
})();
